import { POST } from './API';

const PATH_ROOT = 'U010';

export async function A01(lang: string, cancellation?: AbortSignal) {
  return await POST(`${PATH_ROOT}/faq`, {
    lang: lang,
    signal: cancellation,
  });
}
